import React from "react";
import CKEditor from "react-ckeditor-component-4";

const CKeditorComponent = (props) => {
    const { content, onChange, isMetric = false } = props;
    const config = {
        width: "840px",
        height: "500px",
        versionCheck: false,
        extraPlugins: "videodetector",
        extraAllowedContent: "iframe[*]",
        allowedContent: true,
        removePlugins: 'iframe, easyimage, cloudservices',
        toolbar: [
            {
                name: "basicstyles",
                items: [
                    "Undo",
                    "Redo",
                    "-",
                    "Bold",
                    "Italic",
                    "Underline",
                    "Strike",
                    "-",
                    "Cut",
                    "Copy",
                    "-",
                    "JustifyLeft",
                    "JustifyCenter",
                    "JustifyRight",
                    "JustifyBlock",
                    "-",
                    "Subscript",
                    "Superscript",
                    "-",
                    "RemoveFormat",
                ],
            },
            { name: "colors", items: ["TextColor", "BGColor"] },
            "/",
            { name: "styles", items: ["Styles", "Format", "Font", "FontSize"] },
            {
                name: "paragraph",
                items: ["NumberedList", "BulletedList", "-", "Outdent", "Indent"],
            },
            { name: "editing", items: ["Find", "Replace", "-", "SelectAll"] },
            { name: "links", items: ["Link", "Unlink"] },
            { name: "tools", items: ["iframe", "Maximize", "Preview", "Smiley", "SpecialChar"] },
            (isMetric == true) && "/",
            (isMetric == true) && { name: "insert", items: ["VideoDetector"] },
        ],
    };

    return (
        <>
            <CKEditor
                activeClass="p10"
                isScriptLoaded={false}
                scriptUrl={"../../ckeditor/ckeditor.js"}
                config={props.config ? props.config : config}
                content={content}
                events={{
                    change: onChange,
                }}
            />
        </>
    );
};

/** CKeditor Modal View Component */
export const CKeditorModalComponent = (props) => {
    const { readOnly = false, isMetric = false } = props;
    props = {
        ...props,
        config: {
            width: "405px",
            height: "400px",
            versionCheck: false,
            extraPlugins: "videodetector",
            extraAllowedContent: "iframe[*]",
            allowedContent: true,
            removePlugins: "iframe, easyimage, cloudservices",
            toolbar: [
                {
                    name: "basicstyles",
                    items: [
                        "Undo",
                        "Redo",
                        "-",
                        "Bold",
                        "Italic",
                        "Underline",
                        "Strike",
                        "-",
                        "Cut",
                        "Copy",
                        "-",
                        "JustifyLeft",
                        "JustifyCenter",
                        "JustifyRight",
                        "JustifyBlock",
                        "-",
                        "RemoveFormat",
                    ],
                },
                "/",
                { name: "colors", items: ["Subscript", "Superscript", "-", "TextColor", "BGColor"] },
                {
                    name: "paragraph",
                    items: ["NumberedList", "BulletedList", "-", "Outdent", "Indent"],
                },
                { name: "editing", items: ["Find", "Replace", "-", "SelectAll"] },
                "/",
                { name: "links", items: ["Link", "Unlink"] },
                { name: "tools", items: ["Smiley", "SpecialChar", "-", "Maximize", "Preview"] },
                isMetric == true && "/",
                isMetric == true && { name: "insert", items: ["VideoDetector"] },
            ],
            readOnly: readOnly,
        },
    };
    return <CKeditorComponent {...props}></CKeditorComponent>;
};
export default CKeditorComponent;
